module.exports = "https://deal-img.imgix.net/consumer/background.4a59d499.jpg";